/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InfoIndicatorAPI
 * @hideconstructor
 * @classdesc API class used by InfoIndicator
 */
define([], () => {
	class InfoIndicatorAPI {

		/**
		 * @function InfoIndicatorAPI#update
		 * @description Updates the view
		 */
		update() {}

		/**
		 * @function InfoIndicatorAPI#clearMessagesByIdAndSubtype
		 * @description Clear messages of given type and id.
		 * @param {object} object has id and type of messages to be cleared.
		 */
		clearMessagesByIdAndSubtype() {}

		/**
		 * @function InfoIndicatorAPI#clearMessagesWithIds
		 * @description Clear messages of given type
		 * @param {string} The type of messages to be cleared.
		 */
		clearMessagesWithIds() {}

		/**
		 * @function InfoIndicatorAPI#reset
		 * @description Reset the information messages
		 */
		reset() {}
	}

	return InfoIndicatorAPI;
});
